// A colon followed by digits is a port, as in example.com:8080, not a scheme.
const schemePattern = /^(?:https?:|[a-z][a-z0-9+.-]*:(?!\d))/i

// Returns the link as an http(s) URL, adding https:// when no scheme was typed, or null if it is invalid.
export function normalizeHttpUrl(value: string): string | null {
	const trimmed = value.trim()
	if (trimmed.length === 0) return null

	const withScheme = schemePattern.test(trimmed) ? trimmed : `https://${trimmed}`
	try {
		const url = new URL(withScheme)
		if (url.protocol !== "http:" && url.protocol !== "https:") return null
		if (!url.hostname.includes(".")) return null
		return url.href
	} catch {
		return null
	}
}
